import type { ResourceThemeWithResources } from "@dune/types";
import { Badge, Button } from "@dune/ui";
import { ColumnDef } from "@tanstack/react-table";
import { Trash2 } from "lucide-react";

interface ResourceThemesColumnsOptions {
	onDelete: (theme: ResourceThemeWithResources) => void;
}

export const getResourceThemesColumns = ({
	onDelete,
}: ResourceThemesColumnsOptions): ColumnDef<ResourceThemeWithResources>[] => [
	{
		accessorKey: "name",
		header: "Thème",
		cell: ({ row }) => <span className="truncate">{row.original.name}</span>,
	},
	{
		id: "resourcesCount",
		header: "Ressources liées",
		cell: ({ row }) => (
			<Badge variant="outline">{row.original.resources.length}</Badge>
		),
	},
	{
		id: "actions",
		header: "Actions",
		cell: ({ row }) => (
			<div className="flex justify-end">
				<Button
					type="button"
					variant="ghost"
					size="icon"
					onClick={() => onDelete(row.original)}
				>
					<Trash2 className="h-4 w-4 text-red-600" />
				</Button>
			</div>
		),
	},
];
